import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollTo } from 'react-scroll';
import { Element } from 'react-scroll';

const Banner = () => {
    
  return (
    <Element
      name="PublicSectorSolutions"
      className="aura-ai-banner banner-style-1 height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-7 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center color-body2">
                  <Link className="color-body2" to="/">Home</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  Public Sector
                </div>
                <h1 className="datatalent-program-title color-white title mt-4"><span className="product-banner-title">Public Sector</span> AI Solutions</h1>
                <p className="product-description">Enabling Data-Driven, Transparent, and Equitable Public Services with our AI solutions</p>
                <p className="color-body2">Governments and Public organizations face immense pressure to modernize services, improve responsiveness, and manage limited resources effectively. At M2M Tech, we help public institutions harness AI and Edge technologies to deliver smarter policies, automate regulatory oversight, and enhance citizen services-while ensuring privacy and accountability.</p>
                <div className="read-more-btn banner-btns">
                  <ScrollTo
                    className="edu-btn btn-secondary text-center"
                    to="AISolutions"
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    Learn More<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </ScrollTo>
                  <Link className="edu-btn btn-primary text-center" to="/contact-us">
                    Contact Us<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-5 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <img className="edge-ai-banner-right-image" src={`${process.env.PUBLIC_URL}/images/solutions/illustration_publicsector.png`} alt="M2M Edge AI device" loading="lazy" />
          </div>
        </div>
      </div>
    </Element>
  )
}

export default Banner;